import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _fileTypeExtensions;

import { FileMimeType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { isNumber } from '@yoweb/utils/isNumber';
/**
 * Convert a mime type of a file from a string to a FileMimeType.
 *
 * @param mimeType - the mime type of a file.
 */

export function getFileTypeFromMime(mimeType) {
  switch (mimeType) {
    case 'image/jpeg':
      return FileMimeType.FILE_MIME_TYPE_JPEG;

    case 'image/png':
      return FileMimeType.FILE_MIME_TYPE_PNG;

    case 'application/pdf':
      return FileMimeType.FILE_MIME_TYPE_PDF;

    case 'image/heic':
    case 'image/heif':
      return FileMimeType.FILE_MIME_TYPE_HEIC;

    case 'video/quicktime':
      return FileMimeType.FILE_MIME_TYPE_MOV;

    case 'video/mp4':
      return FileMimeType.FILE_MIME_TYPE_MP4;

    case 'image/gif':
      return FileMimeType.FILE_MIME_TYPE_GIF;

    default:
      return FileMimeType.FILE_MIME_TYPE_UNSPECIFIED;
  }
}
var nextSupportedImageMimeType = {
  FILE_MIME_TYPE_GIF: FileMimeType.FILE_MIME_TYPE_GIF,
  FILE_MIME_TYPE_PNG: FileMimeType.FILE_MIME_TYPE_PNG,
  FILE_MIME_TYPE_JPEG: FileMimeType.FILE_MIME_TYPE_JPEG
};
var supportedImageMimeType = {
  FILE_MIME_TYPE_GIF: FileMimeType.FILE_MIME_TYPE_GIF,
  FILE_MIME_TYPE_PNG: FileMimeType.FILE_MIME_TYPE_PNG,
  FILE_MIME_TYPE_JPEG: FileMimeType.FILE_MIME_TYPE_JPEG,
  FILE_MIME_TYPE_HEIC: FileMimeType.FILE_MIME_TYPE_HEIC
};
var supportedFileMimeType = {
  FILE_MIME_TYPE_PDF: FileMimeType.FILE_MIME_TYPE_PDF,
  FILE_MIME_TYPE_DOC: FileMimeType.FILE_MIME_TYPE_DOC,
  FILE_MIME_TYPE_EXCEL: FileMimeType.FILE_MIME_TYPE_EXCEL,
  FILE_MIME_TYPE_PLAIN_TEXT: FileMimeType.FILE_MIME_TYPE_PLAIN_TEXT
};
export var fileTypeExtensions = (_fileTypeExtensions = {}, _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_UNSPECIFIED, 'UNSPECIFIED'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_JPEG, 'JPEG'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_PNG, 'PNG'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_PDF, 'PDF'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_HEIC, 'HEIC'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_MOV, 'MOV'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_MP4, 'MP4'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_GIF, 'GIF'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_DOC, 'DOC'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_EXCEL, 'EXCEL'), _defineProperty(_fileTypeExtensions, FileMimeType.FILE_MIME_TYPE_PLAIN_TEXT, 'TEXT'), _fileTypeExtensions);
export var getFileExtensionByMimeType = function getFileExtensionByMimeType(mimeType) {
  return fileTypeExtensions[mimeType];
};

var isMimeTypeChecker = function isMimeTypeChecker(supportedMimeTypes) {
  return function (mimeType) {
    if (!isNumber(mimeType)) {
      return Object.keys(supportedMimeTypes).includes(mimeType);
    }

    return Object.values(supportedMimeTypes).includes(mimeType);
  };
};
/**
 * Checks if mime type is image mime type.
 * Supports both enum keys and value checks.
 */


export var isImageMimeType = isMimeTypeChecker(supportedImageMimeType);
/**
 * Checks if mime type is a supported image mime type.
 * Supports both enum keys and value checks.
 */

export var isSupportedImageMimeType = isMimeTypeChecker(nextSupportedImageMimeType);
/**
 * Checks if mime type is file mime type.
 * Supports both enum keys and value checks.
 */

export var isFileMimeType = isMimeTypeChecker(supportedFileMimeType);
/**
 * Checks if file mime type is a valid document
 */

export var isDocument = function isDocument(fileMimeType) {
  if (fileMimeType === FileMimeType.FILE_MIME_TYPE_UNSPECIFIED) {
    return false;
  }

  return fileMimeType ? !isImageMimeType(fileMimeType) : true;
};
export var mapFileUuid = function mapFileUuid(_ref) {
  var fileUuid = _ref.fileUuid;
  return {
    fileUuid: fileUuid
  };
};